import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Container } from '@mui/material';
import { motion as m } from '../brand/tokens';

const MotionContainer = motion.create(Container);

export const pageTransition = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0, transition: { duration: m.duration.slow, ease: m.ease.enter } },
  exit: { opacity: 0, y: -8, transition: { duration: m.duration.fast, ease: m.ease.exit } },
};

/** Frosted card used for forms and content blocks. */
export const cardSx = {
  bgcolor: 'rgba(255, 255, 255, 0.86)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  borderRadius: 6,
  p: { xs: 2.5, sm: 4 },
  boxShadow: '0 24px 60px -32px rgba(139, 29, 29, 0.45)',
  border: '1px solid rgba(255, 255, 255, 0.8)',
};

/** Route-level wrapper: shared spacing under the nav/Aurora, page transition and document title. */
function Page({ title, maxWidth = 'sm', children, sx }) {
  useEffect(() => {
    document.title = title ? `${title} · Groni` : 'Groni — Find the perfect ratio.';
  }, [title]);

  return (
    <MotionContainer
      component="main"
      maxWidth={maxWidth}
      {...pageTransition}
      sx={{
        position: 'relative',
        zIndex: 1,
        flex: 1,
        pt: 'calc(var(--safe-top) + clamp(128px, 20vh, 200px))',
        pb: 6,
        pl: 'max(16px, var(--safe-left))',
        pr: 'max(16px, var(--safe-right))',
        ...sx,
      }}
    >
      {children}
    </MotionContainer>
  );
}

export default Page;
